import axios from "axios";

/**
 * SEPOMEX zip code response shape.
 * API returns Spanish field names.
 */
export interface ZipCodeData {
  zip_code: string;
  municipio: string;
  estado: string;
  ciudad: string;
  colonias: string[];
}

export const DEFAULT_ZIP_CODES_BASE_URL =
  "https://api.zip-codes.multiburo.com.mx";

export const resolveZipCodesBaseUrl = (baseUrl?: string): string => {
  const normalizedBaseUrl = baseUrl?.trim();

  return normalizedBaseUrl || DEFAULT_ZIP_CODES_BASE_URL;
};

const ZIP_CODES_BASE_URL = resolveZipCodesBaseUrl(
  import.meta.env.VITE_ZIP_CODES_API_URL,
);

const REQUEST_TIMEOUT_MS = 5_000;

export const getZipCode = async (zipCode: string): Promise<ZipCodeData> => {
  const { data } = await axios.get<ZipCodeData>(
    `${ZIP_CODES_BASE_URL}/zip-code/${zipCode}`,
    { timeout: REQUEST_TIMEOUT_MS },
  );
  return data;
};
